import * as React from "react";
import { forwardRef } from "react";
const SvgIcPip32 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "ic-PIP-32" }, /* @__PURE__ */ React.createElement("g", { id: "Vector" }, /* @__PURE__ */ React.createElement("path", { d: "M5 6.5H10.5V9H5V24H27V20.5H29.5V24L27 26.5H5L2.5 24V9L5 6.5Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M29.5 6.5H13.5V17.5H29.5V6.5Z", fill: "currentColor" }))));
const ForwardRef = forwardRef(SvgIcPip32);
export { ForwardRef as ReactComponent };
